function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "85A77A9A-05FE-4412-BB9F-00E2E3BAA528");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Design-systems",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Form-elements",
  transform: "translate(-940.000000, -850.000000)",
  fill: "#529C4E",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "copy-icon",
  transform: "translate(940.000000, 850.000000)"
}, React.createElement("path", {
  d: "M8.79016393,0 L1.26229508,0 C0.573770492,0 0,0.550819672 0,1.26229508 L0,10.0295082 L1.26229508,10.0295082 L1.26229508,1.26229508 L8.76721311,1.26229508 L8.76721311,0 L8.79016393,0 Z M10.6721311,2.50163934 L3.78688525,2.50163934 C3.09836066,2.50163934 2.52459016,3.05245902 2.52459016,3.76393443 L2.52459016,12.5311475 C2.52459016,13.2196721 3.07540984,13.7934426 3.78688525,13.7934426 L10.6721311,13.7934426 C11.3606557,13.7934426 11.9344262,13.242623 11.9344262,12.5311475 L11.9344262,3.76393443 C11.9114754,3.07540984 11.3606557,2.50163934 10.6721311,2.50163934 Z M10.6721311,12.5081967 L3.78688525,12.5081967 L3.78688525,3.76393443 L10.6721311,3.76393443 L10.6721311,12.5081967 Z"
}))));

var SvgCopyIcon = function SvgCopyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCopyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy-icon.72f7f590.svg";
export { ForwardRef as ReactComponent };